export default "__VITE_ASSET__20675649__"